export default __webpack_public_path__ + "static/media/starCircle.d93c8552.svg";